import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "./constants";

export const StyledPricingColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: calc(100% - 40px);
  margin: auto;
  min-height: 475px;
  margin-top: 35px;
  justify-content: center;
  gap: 24px;

  ${({ isLegacy }) => isLegacy && `justify-content: center; margin-top: 0;`}
  margin-bottom: 0px;
  ${({ isCurrentPlan, isLegacy }) => !isCurrentPlan && isLegacy && `height: auto; margin-bottom: 40px;`};

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    flex-direction: column;
    margin-top: 0px;
    ${({ isLegacy }) => isLegacy && `margin-bottom: 0px;`}

    align-items: center;
    width: 100%;
    gap: 32px;
  }
`;

export const StyledCancelGuarantee = styled.div`
  margin: auto;
  width: 370px;
  padding: 20px;
  ${({ extraPadding }) => extraPadding && `padding-top: 100px;`}

  h3 {
    font-family: "GT Super Text";
  }

  p {
    margin-top: 10px;
    font-family: "GT Super Text";
    line-height: 19px;
    font-weight: 300;
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    width: auto;

    h3 {
      font-size: 24px;
    }
    p {
      font-size: 20px;
      font-weight: normal;
    }
  }
`;

export const StyledOneOnOneOnboarding = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 80px;
  width: 400px;

  ${({ extraPadding }) => extraPadding && `padding-top: 100px;`}

  h3 {
    font-family: "GT Super Text";
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
  }

  .price {
    font-family: "GT Super Text";
    font-size: 32px;
    font-weight: 400;
    margin-top: 20px;
  }

  p {
    margin-top: 20px;
    font-family: "GT Super Text";
    font-size: 15px;
    line-height: 24px;
    font-weight: 400;
    color: #383838;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #3838381A;
    border-radius: 10px;
    padding: 40px;
  }

  button {
    /* padding: 20px; */
    font-size: 16px;
    cursor: pointer !important;
    width: 195px;
    border-radius: 10px !important;
    background: linear-gradient(to right, rgb(44, 220, 118) -100%, rgb(16, 168, 217) 200%) !important;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    width: auto;

    h3 {
      font-size: 24px;
    }
    p {
      font-size: 20px;
      font-weight: normal;
    }
  }
`;

export const StyledPricing = styled.div`
  overflow-x: hidden;

  button {
    font-size: 16px;
    background: #4808d1;
    color: #fff;
    border: 0;
    border-radius: 20px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
  }

  background: #f5f2e4;
  text-align: center;
  margin-top: 0;
  padding-top: 0;
  font-family: "GT Super Text";
  padding-bottom: 80px;
  ${({ notLoaded }) => notLoaded && `min-height:100vh;`}

  > div,
  section {
    padding-left: 0;
    padding-right: 0;
  }

  ${({ modalOpen }) => modalOpen && `filter: brightness(0.5);`}

  section > span {
    display: block;
    margin: 30px;
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    color: #727272;

    &.pricing-subhead {
      font-family: "GT Super Text";
      font-weight: 300;
    }

    &:nth-child(1) {
      font-family: "Inter";
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.17em;
    }
  }

  .sub-first-refund-notice {
    font-family: "GT Super Text";
    font-size: 15px;
    color: #666;
    margin: 24px auto 0 auto;
    font-style: italic;
  }

  h1,
  h2 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 54px;
    text-align: center;
    margin: auto;

    &.manage {
      font-size: 35px;
      font-weight: 400;
    }
  }

  h2 {
    font-size: 45px !important;
  }

  .transition-header {
    max-width: 800px;
    margin: auto;
  }

  .our-new-plans {
    margin-top: -80px;
    max-height: 40vh;
    margin-bottom: -60px;
    max-width: 90vw;
  }

  .concierge-disclaimer {
    font-size: 14px;
    margin-bottom: 40px;
  }

  .show-more {
    display: block;
    /* min-height: 100vh; */
    height: 460px;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 20px !important;
      border-radius: 15px !important;
    }
  }

  .interval-switch {
    text-align: center;
    display: flex;
    width: 266px;
    align-items: center;
    margin: 45px auto 0 auto;
    font-weight: 500;
    font-family: Inter;
    font-size: 18px;
    color: #7b7972;

    @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
      + ${StyledPricingColumnContainer} {
        margin-top: 24px;
      }
    }

    div {
      span {
        font-weight: 500;
        display: block;
        font-size: 14px;
        margin-top: 5px;
        color: #7b7972;
        opacity: 0.6;
      }
    }

    .switch {
      //this css is duplicated in the guidance styles, consider componentizing or backing out to root
      position: relative;
      display: block;
      width: 60px;
      height: 32px;
      margin: auto;

      input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.15);
        transition: 0.4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 34px;
        width: 34px;
        left: -1px;
        bottom: -1px;
        background-color: white;
        transition: 0.4s;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
      }

      input:checked + .slider {
        background-color: #1ec1a8;
      }

      input:checked + .slider:before {
        transform: translateX(30px);
        background-color: white;
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }

  /* when the mid breakpoint is activated and we show the legacy plan above the other plans */
  .legacy-mid-container {
    text-align: center;

    .position-comparison {
      margin: 25px auto;
    }

    .scroll-down {
      display: inline-block;
      position: relative;
      letter-spacing: normal;
      color: white;
      background: #1fc2a9;
      border-radius: 18px;
      font-weight: 700;
      font-size: 13px;
      font-family: Inter;
      transform: rotate(-10deg);
      margin: 0 auto 60px;
      padding: 7px 12px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
      font-weight: bold;
      line-height: 1.4em;

      span {
        font-weight: 500;
        display: block;
        opacity: 0.65;
      }

      svg {
        position: absolute;
        bottom: -59px;
        left: 50%;
        width: 30px;
        transform: translateX(-50%) rotate(10deg);
      }
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    overflow-x: hidden;

    .our-new-plans {
      margin-top: 0px;
      margin-bottom: 0px;
    }
    > div,
    section {
      padding: 30px;
      padding-right: 25px;
      box-sizing: border-box;
    }
    section {
      h1 {
        font-size: 32px;
        line-height: 1.3em;
        font-weight: 600;
      }

      > span {
        &:nth-of-type(1) {
          font-size: 18px;
          margin-bottom: 5px;
          /* letter-spacing: 1px; */
        }

        &:nth-of-type(2) {
          font-size: 22px;
          margin-bottom: 25px;
        }
      }
    }
  }
`;

export const StyledNav = styled.nav`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  img {
    padding: 24px;
    width: 80px;
    opacity: 0.5;
  }

  ul {
    list-style-type: none;

    li {
      display: inline-block;
      font-family: "Inter";
      font-weight: 500;
      padding: 24px 5px 24px 24px;

      &:last-child {
        padding-right: 36px;
      }

      a {
        color: #2b2315;
        opacity: 0.5;
      }
    }
  }
`;

export const StyledControls = styled.div`
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;

  li {
    margin: 10px;
  }

  border-bottom: 1px solid black;
`;
